

export class ToolTipOptionUpdateInput implements IToolTipOptionUpdateInput {
    /** The auto-generated id of the tool tip option master */
    tooltipOptionId!: number;
    /** The tool tip option name  with 255 character limit */
    tooltipOptionName!: string;

    constructor(data?: IToolTipOptionUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltipOptionId = _data["tooltipOptionId"];
            this.tooltipOptionName = _data["tooltipOptionName"];
        }
    }

    static fromJS(data: any): ToolTipOptionUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipOptionUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipOptionId"] = this.tooltipOptionId;
        data["tooltipOptionName"] = this.tooltipOptionName;
        return data; 
    }
}

export interface IToolTipOptionUpdateInput {
    /** The auto-generated id of the tool tip option master */
    tooltipOptionId: number;
    /** The tool tip option name  with 255 character limit */
    tooltipOptionName: string;
}

